module.exports = __webpack_public_path__ + "img/cart-bold-filled-20x20.71d215dd.svg";